import React from 'react'

const ThumbsDownIcon = () => {
    return (
        <div>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M21 0H3C2.20435 0 1.44129 0.31607 0.87868 0.87868C0.31607 1.44129 0 2.20435 0 3V21C0 21.7956 0.31607 22.5587 0.87868 23.1213C1.44129 23.6839 2.20435 24 3 24H21C21.7956 24 22.5587 23.6839 23.1213 23.1213C23.6839 22.5587 24 21.7956 24 21V3C24 2.20435 23.6839 1.44129 23.1213 0.87868C22.5587 0.31607 21.7956 0 21 0ZM7.59259 5H5V12.2593H7.59259V5ZM8.62963 5H15.8889C16.8511 5.00137 17.7735 5.38422 18.4539 6.06461C19.1343 6.745 19.5171 7.66741 19.5185 8.62963V12.2593C19.5178 12.8091 19.2991 13.3363 18.9103 13.7251C18.5215 14.1139 17.9943 14.3326 17.4444 14.3333H13.2963V17.4444C13.2959 17.8569 13.1319 18.2523 12.8402 18.5439C12.5486 18.8356 12.1532 18.9996 11.7407 19H11.6723C11.4229 18.9991 11.1821 18.9087 10.9936 18.7454C10.8051 18.582 10.6815 18.3565 10.6451 18.1097L10.207 15.0416L8.62963 12.6756V5Z" fill="#A2ABB3" />
            </svg>

        </div>
    )
}

export default ThumbsDownIcon
